export class DodajKomentarzDoEwidencji {
  id: string;
  idProjektu: string;
  tresc: string;
  czyKomentowanieWielu: boolean = false;
  idRekordow: Array<string>;
}
